import LoginForm from "../../components/Login/LoginForm/LoginForm";

export function Login(){
    return <LoginForm />
}
